import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getBlog } from "./BlogApi";

const initialState = {
    blog: {},
    isLoading: false,
    isError: false,
    error: ''
}

export const fetchBlog = createAsyncThunk("blog/fetchBlog", async(id) =>{
    const blog = await getBlog(id);
    return blog
})

const BlogSlice = createSlice({
    name: "blog",
    initialState,
    reducers: {
        toggleSaved: (state,action) => {
            state.blog.isSaved = !state.blog.isSaved
        },
        likeCount: (state,action) => {
            state.blog.likes += 1
        }
    },
    extraReducers: (builder) =>{
        builder
        .addCase(fetchBlog.pending, (state) =>{
            state.isError = false;
            state.isLoading = true; 
        })
        .addCase(fetchBlog.fulfilled, (state,action) =>{
            state.isLoading = false; 
            state.blog = action.payload;
        })
        .addCase(fetchBlog.rejected, (state,action) =>{
            state.isLoading = false; 
            state.blog = {};
            state.isError = true;
            state.error = action.error?.message;
        })
    }
})


export default BlogSlice.reducer;
export const {toggleSaved, likeCount} = BlogSlice.actions;